import axios from "axios";

export async function fetcher(url: string, accessToken: string) {
  try {
    const response = await axios.get(
      process.env.NEXT_PUBLIC_API_GATEWAY + url,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch:", error);
    throw new Error("Failed to fetch");
  }
}

export async function localFetcher(url: string, accessToken: string) {
  try {
    const response = await axios.get("http://localhost:4000" + url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch:", error);
    throw new Error("Failed to fetch");
  }
}
